import { render } from "./InviteItem.vue?vue&type=template&id=72cb7e16&ts=true"
import script from "./InviteItem.ts?vue&type=script&lang=ts&external"
export * from "./InviteItem.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__